import React from "react";
import logo from "../../assets/logo.png";
import "bootstrap/dist/css/bootstrap.min.css";

const LandingPage = () => {
  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-dark shadow-sm">
        <div className="container">
          <a className="navbar-brand fw-bold text-light-gradient" href="/">
            SADARTALAUD
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
            <ul className="navbar-nav"></ul>
          </div>
          <div className="nav-login d-flex align-items-center gap-3">
            <a className="btn-login ms-auto" href="/login">
              Login
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-5 text-center bg-light">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center justify-content-center">
              <img className="lp_logo" src={logo} alt="Logo Aplikasi SADARTALAUD" />
            </div>
            <div className="col-md-6 d-flex flex-column align-items-center justify-content-center">
              <h1 className="display-5 fw-bold text-gradient">
                Aplikasi Data Rumah & Pendataan RTLH Kabupaten Talaud
              </h1>
              <p className="lead text-muted">
                <strong>SADARTALAUD</strong> adalah aplikasi resmi Kabupaten Talaud untuk <strong>pendataan rumah</strong>, 
                <strong>Rumah Tidak Layak Huni (RTLH)</strong>, serta pengelolaan <strong>Satu Data Rumah Talaud</strong>. 
                Dengan fitur peta interaktif, laporan lengkap PDF/Excel, dan dashboard terintegrasi.
              </p>
              <a href="/login" className="btn btn-primary btn-sm mt-3">
                Masuk Aplikasi
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-5">
        <div className="container">
          <h2 className="text-center fw-bold mb-4">Fitur Utama SADARTALAUD</h2>
          <div className="row text-center">
            <div className="col-md-4">
              <div className="card shadow-sm p-4 lp-card">
                <h3>📊 Data Terintegrasi</h3>
                <p className="text-muted">
                  Kelola dan integrasikan <strong>data rumah</strong> secara cepat, akurat, dan terpusat.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow-sm p-4 lp-card">
                <h3>🌍 Peta Interaktif</h3>
                <p className="text-muted">
                  Visualisasi lokasi rumah & <strong>pendataan RTLH</strong> melalui peta interaktif.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow-sm p-4 lp-card">
                <h3>📑 Laporan Lengkap</h3>
                <p className="text-muted">
                  Ekspor laporan data rumah dalam format <strong>PDF</strong> dan <strong>Excel</strong> dengan mudah.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-5 bg-primary text-white text-center">
        <div className="container">
          <h2 className="fw-bold">Mulai Pendataan Rumah Sekarang</h2>
          <p>Gunakan Aplikasi SADARTALAUD untuk mendukung program <strong>pendataan RTLH</strong> dan pengelolaan data rumah di Kabupaten Talaud.</p>
          <a href="/login" className="btn btn-light btn-lg mt-3">Login & Mulai</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-white text-center py-3">
        <p className="my-0">© 2025 SADARTALAUD - Disperkim Kabupaten Talaud | Aplikasi Data Rumah & Pendataan RTLH</p>
      </footer>
    </div>
  );
};

export default LandingPage;
